import { task } from '#utilities/js/ea/submitter.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const onClick = object(listener, {
  type: click,
  task
})

export default button => {
  onClick.listen(button)
}
